module.exports = __webpack_public_path__ + "media/images/dogs/puppy_weight_cropped/American Bully.jpg";